@use "variables" as *;

.description {
  width: 100%;
  font-size: $fontSize-xs;
  font-weight: bold;
  text-align: center;
}

.card {
  width: $grade-card-width;
  height: $grade-card-height;
}
